<template>
  <div>
    <div class="form-group" v-show="this.data.visibility !== 'hidden'">
      <label v-show="this.showLabel"> {{label}} </label>
      <datetime v-model="value" :type="type" input-class="form-control" :name="this.data.tag"
                :placeholder="placeholder"></datetime>
      <small class="form-text text-muted" v-show="data.help_text != ''">{{data.help_text}}</small>
    </div>
  </div>
</template>

<script>

	// Import this component
	import {Datetime} from 'vue-datetime';


	export default {
		props: ['label', 'data', 'value', 'type', 'showPlaceholder', 'showLabel'],
		data() {
			return {}
		},
		computed: {
			placeholder() {
				return this.showPlaceholder ? this.label : ''
			},
		},
		components: {
			Datetime
		}
	}


</script>
